import {Network} from "../../../network/Network";
import {ProductType} from "../../../models/product/ProductType";
import {HttpStatus} from "../../../network/status/HttpStatus";
import {WebSocketCommunityEventName} from "../../../network/socket/names/WebSocketCommunityEventName";
import {INetworkComponent} from "../../../network/types/INetworkComponent";
import {arrayRemove} from "../../../sedestral/framework/utilities/ArrayRemove";
import {ICommunitySEOAuditGetPageOutgoing} from "../../../models/community/seo/audit/ICommunitySEOAuditGetPageOutgoing";
import {ICommunitySEOAuditPagesIncoming} from "../../../models/community/seo/audit/ICommunitySEOAuditPagesIncoming";
import {ICommunitySEOAuditOverviewModel} from "../../../models/community/seo/audit/ICommunitySEOAuditOverviewModel";
import {ICommunitySEOAuditModel} from "../../../models/community/seo/audit/ICommunitySEOAuditModel";
import {ICommunitySEOAuditPageModel} from "../../../models/community/seo/audit/ICommunitySEOAuditPageModel";
import {Services} from "../../Services";
import {ErrorCode} from "../../../network/status/error/ErrorCode";
import {Resources} from "../../../resources/Resources";

export class CommunitySeoAuditService {

    public static events: ((auditModel: ICommunitySEOAuditModel) => void)[] = [];

    public static dispose(): void {
        this.events = [];
    }

    public static init(): void {
        Network.on(ProductType.COMMUNITY, WebSocketCommunityEventName.COMMUNITY_SEO_AUDIT_UPDATE, (data: ICommunitySEOAuditModel) => {
            this.events.forEach(value => value(data));
        });
    }

    public static async create(communityId: string, component?: INetworkComponent): Promise<ICommunitySEOAuditModel> {
        Services.handleErrors(component, [
            {
                errorCode: ErrorCode.AUDIT_ALREADY_RUNNING,
                message: Resources.t("words.auditAlreadyRunningMessage")
            }
        ]);

        let request = await Network.post(ProductType.COMMUNITY, `/community/seo/audit/create/${communityId}`, {}, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
    }

    public static async getPageByUrl(data: {
        pageUrl: string,
        auditId: string,
        communityId: string
    }, component?: INetworkComponent): Promise<ICommunitySEOAuditPageModel> {
        let request = await Network.post(ProductType.COMMUNITY, `/community/seo/audit/page`, data, component);

        if (request.status == HttpStatus.OK) {
            return request.data;
        }
    }

    public static async getById(auditId: string, communityId: string, component?: INetworkComponent): Promise<ICommunitySEOAuditModel> {
        let request = await Network.get(ProductType.COMMUNITY, `/community/seo/audit/${auditId}/${communityId}`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
    }

    public static async getPages(pageOutgoing: ICommunitySEOAuditGetPageOutgoing, component?: INetworkComponent): Promise<ICommunitySEOAuditPagesIncoming> {
        let request = await Network.postJson(ProductType.COMMUNITY, "/community/seo/audit/pages", pageOutgoing, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
    }

    public static async getOverviews(communityId: string, component?: INetworkComponent): Promise<ICommunitySEOAuditOverviewModel[]> {
        let request = await Network.get(ProductType.COMMUNITY, `/community/seo/audit/overviews/${communityId}`, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
    }

    static onAuditUpdate(component: INetworkComponent, func: (audit: ICommunitySEOAuditModel) => void) {
        this.events.push(func);
        component.onRemove(() => arrayRemove(this.events, func));
    }
}